import {Model} from "./Model";
import {IRound, IApiSwiss} from "../typings/apiResponse";
import {Cup} from "./Cup";
import * as angular from "angular";

export class Round extends Model {
    constructor(private apiResponse: IRound) {
        super(apiResponse);
    }

    public getBegin() {
        return this.apiResponse.begin;
    }

    public getSeedingType() {
        return this.apiResponse.seedingType;
    }
}

/**
 * @ngdoc overview
 *
 * @type {Object}
 * @name ngLeague.Cup
 *
 * @requires apiResponse
 *
 * @description
 * The cup object represents a swiss cup on ESL Play. It can be build using an API response for a swiss cup directly or by
 * calling the factory method in {@link ngLeague.League}.
 */
export class Swiss extends Cup {
    constructor(private apiResponse: IApiSwiss) {
        super(apiResponse);
    }

    public getCurrentRound() {
        return this.apiResponse.currentRound;
    }

    public getMaxLosses() {
        return this.apiResponse.maxLosses;
    }

    public getRounds() {
        var rounds = [];

        angular.forEach( this.apiResponse.rounds, (round: IRound) => {
            rounds.push(new Round(round));
        });

        return rounds;
    }

    public getRound(index: number) {
        if (this.apiResponse.rounds.length <= index) {
            return null;
        }

        return new Round(this.apiResponse.rounds[index]);
    }

    /**
     * @param round
     * @returns {number}
     */
    public getSecondsUntilRound(round: Round) {
        var date: Date;

        if (round === null) {
            date = new Date(0);
        } else {
            date = new Date(round.getBegin());
        }

        return this.getSecondsUntilDate(date);
    }
}